import { Button, Tooltip } from "@mui/material";
import PersonRemoveIcon from "@mui/icons-material/PersonRemove";
import { useDoLogout } from "src/utils/useDoLogout";

const DeleteAccountButton = ({ color }: { color: string }) => {

  return (
    <Tooltip title="Delete account" arrow placement="top">
      {/* <Button sx={{ color: "#ffffff", p: 0 }} onClick={doLogOut}> */}
      <PersonRemoveIcon sx={{ color: color, p: 0 }} />
      {/* </Button> */}
    </Tooltip>
  );
};

export default DeleteAccountButton;
